import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverCosts from './ReportDriverCosts'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportDriverCosts} />
    </Switch>
)

export default Components
